<template>
	<div class="crud-wrapper">
		<crud-toolbar :isBlocked="formData.blocked" :modal-mode="modalMode" :new-state="newState" :title="modalTitle" @onCommand="toolbarCommand" :showDelete="false" :showBlock="false"></crud-toolbar>

		<crud-form :modal-mode="modalMode" :ref="formName" v-model="validForm">

			<v-layout row wrap>
				<v-flex xs3>
					<v-card flat style="border-radius: 8px;">
						<v-img :aspect-ratio="idRatio" :src="media" style="border-radius: 8px"></v-img>

						<v-toolbar flat>
							<v-spacer></v-spacer>

							<v-tooltip bottom>
								<v-btn @click.stop="loadImgClick" color="primary" dark fab slot="activator" small>
									<v-icon small>fas fa-camera</v-icon>
								</v-btn>
								Carregar Foto
							</v-tooltip>

							<v-spacer></v-spacer>
						</v-toolbar>

					</v-card>
				</v-flex>
				<v-flex xs9>
					<a-text-field autofocus label="Nome" text-transform="capitalize" v-model="formData.name" validate="required" style="padding: 0;"></a-text-field>
					<a-text-field disabled label="Email" v-model="formData.mainEmail" validate="required" style="padding: 0;"></a-text-field>
					<v-layout row>
						<a-text-field disabled label="Whatsapp" md4 v-mask="['(##) ####-####', '(##) #####-####']" md6 v-model="formData.mobileNumber" validate="required"></a-text-field>

						<a-date-field :max="maxDate" dateFormat="DD/MM/YYYY" label="Nascimento" md6 v-model="formData.birth"></a-date-field>
					</v-layout>
				</v-flex>
				<a-text-field label="Endereço" text-transform="capitalize" v-model="formData.address"></a-text-field>
				<a-text-field label="Cidade" md6 text-transform="capitalize" v-model="formData.city"></a-text-field>
				<a-text-field label="Estado" md3 text-transform="uppercase" v-model="formData.state"></a-text-field>
				<a-text-field label="CEP" mask="#####-###" md3 v-model="formData.zipcode"></a-text-field>
			</v-layout>

			<template slot="rightContent">
				<v-tabs centered color="secondary" dark icons-and-text style="border-radius: 12px;">
					<v-tabs-slider color="white"></v-tabs-slider>

					<v-tab href="#tab-1">
						Dados Bancários
						<v-icon>fas fa-university</v-icon>
					</v-tab>

					<v-tab href="#tab-2">
						Redes Sociais
						<v-icon>fas fa-share-alt-square</v-icon>
					</v-tab>

					<v-tab-item value="tab-1">
						<v-card color="rgba(0,0,0, 0.03)" flat style="border-radius: 8px">
							<v-layout>
								<v-flex>
									<v-card-text class="pt-0 mt-3" v-if="formData.bankAccountId">
										<v-layout>
											<div class="invalid-account" v-if="formData.bankAccountIsBlocked || !formData.bankAccountIsActive">
												<div>
													<i class="fas fa-exclamation-triangle"></i>
													<p>Conta inativa ou bloqueada.</p>
												</div>

												<div class="reason" v-if="formData.bankAccountNotes">
													<p>Motivo:</p>
													<p>{{ formData.bankAccountNotes }}</p>
												</div>

												<div>
													<p>Corrija os dados da conta ou do afiliado para que seja desbloqueada e ativada.</p>
												</div>
											</div>
										</v-layout>
										<v-layout row>
											<div style="width: 100%; padding: 0 15px;" v-if="formData.acctType === 'pix'">
												<a-text-field disabled label="Tipo" type="text" style="margin-top: 10px; padding: 0;" v-model="formData.pixType"></a-text-field>
												<a-text-field disabled label="Chave Pix" type="text" style="padding: 0;" v-model="formData.pixKey"></a-text-field>
											</div>
											<div style="width: 100%; padding: 0 15px;" v-else>
												<v-select hide-details box class="clean-style" style="margin-top: 10px;" disabled ref="refBank" label="Banco" :items="getBankList()" placeholder=' ' v-model="formData.bankId"></v-select>
												<a-text-field hide-details disabled label="Conta" type="text" style="padding: 0; margin-top: 5px;" v-model="formData.acctNo"></a-text-field>
												<a-text-field hide-details disabled label="Agência" type="text" style="padding: 0; margin-top: 5px;" v-model="formData.branchNo"></a-text-field>
												<a-text-field hide-details v-if="formData.opNo" disabled label="Operação" type="text" style="padding: 0; margin-top: 5px;" v-model="formData.opNo"></a-text-field>
											</div>
										</v-layout>
									</v-card-text>
									<div class="empty-account" v-else>
										<img alt="Not Found" src="/static/error/notfound.svg">
										<h4>Não há conta bancária cadastrada</h4>
										<p>O cadastro da conta para crédito de suas comissões será realizado durante seu primeiro saque, após atingir o saldo mínimo de {{ minWithdraw | fmtMoney }} em sua carteira.</p>
									</div>
								</v-flex>
							</v-layout>
						</v-card>
					</v-tab-item>
					<v-tab-item value="tab-2">
						<v-card color="rgba(0,0,0, 0.03)" flat style="border-radius: 8px">
							<v-layout>
								<v-flex>
									<v-card-text class="pt-0 mt-3">
										<p>Informe abaixo o link para seus canais nas redes sociais.</p>
										<a-text-field label="Youtube" type="text" style="padding: 0;" v-model="formData.youtube"></a-text-field>
										<a-text-field label="Facebook" type="text" style="padding: 0;" v-model="formData.facebook"></a-text-field>
										<a-text-field label="Instagram" type="text" style="padding: 0;" v-model="formData.instagram"></a-text-field>
										<a-text-field label="Telegram" type="text" style="padding: 0;" v-model="formData.telegram"></a-text-field>
										<a-text-field label="Outros (Separar por ponto e vírgula)" type="text" style="padding: 0;" v-model="formData.others"></a-text-field>
									</v-card-text>
								</v-flex>
							</v-layout>
						</v-card>
					</v-tab-item>
				</v-tabs>
			</template>
		</crud-form>
	</div>
</template>

<script>
import CrudFormClass from '@consigmais-team/vue-common/layout/crudPage/crudFormClass';

export default CrudFormClass.extend({
	name: 'Profile',

	data: function () {
		return {
			title: 'Meu Perfil',
			formName: 'profile',
			bankList: [],
			originalBankId: null,
			minWithdraw: 0,

			formData: {
				id: null,
				name: null,
				mainEmail: null,
				mobileNumber: null,
				birth: null,
				address: null,
				city: null,
				state: null,
				zipcode: null,
				avatar: null,
				youtube: null,
				facebook: null,
				instagram: null,
				telegram: null,
				others: null,

				bankAccountId: null,
				pixKey: null,
				pixType: null,
				bankId: null,
				acctNo: null,
				branchNo: null,
				acctType: null,
				opNo: null,
				bankAccountIsBlocked: null,
				bankAccountIsActive: null,
				bankAccountCreatedAt: null,
				bankAccountType: null,
				bankAccountName: null,
				bankAccountNotes: null,
				bankAccountTypeId: null
			},
			bankDisabled: false,
		};
	},

	watch: {
		'formData.id'(value) {
			if (this.formData.acctNo == null && this.formData.branchNo == null) {
				this.formData.bankId = 27;
				this.bankDisabled = true;
			}
			if (this.formData.bankId) {
				this.originalBankId = this.formData.bankId;
			}
		},
		'originalBankId'(value) {
			if (value && value == 27) {
				this.bankDisabled = true;
			}
		}
	},

	computed: {
		idRatio() {
			let mediaRatio = 3 / 4;
			/*if (this.formData.avatar && this.formData.avatar.size && this.formData.avatar.size.h)
			   mediaRatio = (this.formData.avatar.size.w - 150) / this.formData.avatar.size.h;*/

			return mediaRatio;
		},

		media() {
			let media = '/static/images/no-avatar.jpg';

			if (this.formData.avatar) {
				media = this.$config.imageUri(this.formData.avatar, 'photo');
			}

			return media;
		},

		maxDate() {
			return '2002-01-01';
		},
	},

	methods: {
		loadImgClick() {
			window.cloudinary.openUploadWidget(window.cloudinaryOptions.avatars, this.uploadedMedia);
		},

		uploadedMedia(error, result) {
			if (result && result.length) {
				let res = result[0];
				this.formData.avatar = res.path || res.public_id;
			}
		},

		getBankList() {
			let auxBankList = [];
			if (this.bankList && this.bankList.length) {
				auxBankList = this.bankList
					.filter(el => el.id == this.originalBankId || el.id == 27)
					.map(obj => Object({
						text: obj.name,
						value: obj.id
					}));
			}
			return auxBankList;
		}
	},

	async created() {
		this.editKey = this.$store.state.company.user.id;
		this.bankList = await this.$api.dataService.search('bank');

		try {
			let minWithdraw = await this.$api.dataService.execute('wallet/getMinWithdraw', {});
			this.minWithdraw = minWithdraw.withdrawMin;
		} catch(e) {
			//
		}
	}
});
</script>

<style scoped>
a {
	text-decoration: none;
}

.empty-account {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 25px 0;
	height: 100%;
	font-size: 1.5rem;
	color: #ccc;
}

.empty-account img {
	width: 40%;
}

.empty-account h4 {
	margin-top: 10px;
	color: var(--primary-color);
	font-weight: bold;
}

.empty-account p {
	text-align: center;
	font-weight: light;
	color: #555;
	font-size: 16px;
	width: 80%;
}

.invalid-account {
	width: 100%;
	background-color: var(--danger-background-color);
	margin: 15px 15px 0 15px;
	padding: 20px;
	border-radius: 5px;
	color: black;
}

.invalid-account p {
	font-size: 14px;
	margin: 0;
}

.invalid-account > div {
	margin-top: 3px;
}

.invalid-account > div:first-child {
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-top: 0;
	color: var(--danger-color);
}

.invalid-account > div:nth-child(2) {
	display: flex;
	flex-direction: row;
	align-items: center;
}

.invalid-account > div:nth-child(2) > p:first-child {
	font-weight: bold;
	margin-right: 3px;
}

.invalid-account > div:last-child {
	margin-top: 10px;
}

.invalid-account > div > i {
	margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Profile.vue